import { connect } from 'react-redux';
import { SignInFormPatientProviderModeView } from './SignInFormPatientProviderModeView';
import {
    trackClickFacebookLogin,
    trackClickGoogleLogin,
    trackClickAppleLogin,
    trackClickCreateAccount,
} from './SignInFormPatientProviderModeActions';

export const mapStateToProps = state => {
    if (state.signInForm === undefined) {
        throw new Error(
            'Expected the sign in state to be available as `state.signInForm`. ' +
                "Ensure you have added the `signInReducer` to your store's reducers via `combineReducers`."
        );
    }

    return {
        rememberMe: state.signInForm.rememberMe,
    };
};

export const mapDispatchToProps = {
    onClickFacebookLogin: trackClickFacebookLogin,
    onClickGoogleLogin: trackClickGoogleLogin,
    onClickAppleLogin: trackClickAppleLogin,
    trackClickCreateAccount,
};

export const SignInFormPatientProviderModeContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SignInFormPatientProviderModeView);
